import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { AlertService } from 'src/app/shared/store/alert/alert.service';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';
import { Event } from '../models/event.model';
import { EventService } from '../services/event.service';
import { EventActions } from './event.actions';

export class EventStateModel {
  public events: Event[];
  public isLoadingEvents: boolean;
  public error: string;
}

const defaults = {
  events: [],
  isLoadingEvents: false,
  error: null,
};

@State<EventStateModel>({
  name: 'event',
  defaults
})
@Injectable()
export class EventState {
  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private eventService: EventService,
    public store: Store
  ) {}
  
  @Action(EventActions.GetEvents) GetEvents (ctx: StateContext<EventStateModel>, {}: EventActions.GetEvents) {
    return this.eventService.getEvents().subscribe({
      next: (response) =>
        ctx.dispatch(new EventActions.GetEventsSuccess(response)),
      error: (error) => ctx.dispatch(new EventActions.Error(error)),
    });
  }
  
  @Action(EventActions.GetEventsSuccess) GetEventsSuccess (ctx: StateContext<EventStateModel>, { events }: EventActions.GetEventsSuccess) {
    ctx.patchState({
      events: events.sort((a, b) => a.eventName.localeCompare(b.eventName)),
      isLoadingEvents: false,
    });
  }
  
  @Action(EventActions.Error)
  onErrorOccurred(
    ctx: StateContext<EventStateModel>,
    { error }: EventActions.Error
  ) {
    ctx.patchState({
      error: error,
      isLoadingEvents: false,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }
  
  private getTitle() {
    return this.localizationService.translate('labels.event');
  }
}
